import { useRoutes } from "react-router-dom";
import LandingPage from "./LandingPage.js";
import FERoutes from "./Routs/routes.js";
import { useLocation } from "react-router-dom";
import Network from "./Network/routes.js";
import Question from "./Q&A/routes.js";
import Favorite from "./Favorite/routes.js"
import Settings from "./Setting/routes.js"
import Photos from "./Photos/routes.js"
import Aux from "./Auxx/routes.js"
import Announcement from "./Announcement/routes.js"
import Content from "./Content/routes.js"
import Users from "./Users/routes.js"
import HighSchool from "./HightSchools/routes.js"
import Help from "./Help/routes.js"
import UserMangment from './UserMangment/routes.js'
import ChangePassword from "./Login/ChangePassword.js";
import AdminRoutes from "./Z_/routes.js";
import ProtectedRoute from "./RouteProtect.js"
/*
const NotFound = () => {
  return (
    <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px dashed gray', width: '400px', height: '150px', borderRadius: '20px' }}>
        <div style={{ textAlign: 'center' }}>
          <h4 style={{ fontSize: '22px' }}>404 URL Not Found</h4>
          { <p style={{fontSize: '16px', margin: '0px' }}>Please contact the administrator for more information.</p> }
        </div>
      </div>
    </div>
  )
};


const ModuleRoutesArray = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "network/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Network />
      </ProtectedRoute>)
  },
  {
    path: "q&a/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Question />
      </ProtectedRoute>)
  },
  {
    path: "aux/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Aux />
      </ProtectedRoute>)
  },
  {
    path: "favorite/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Favorite />
      </ProtectedRoute>)
  },
  {
    path: "announcement/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Announcement />
      </ProtectedRoute>)
  },
  {
    path: "users/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Users />
      </ProtectedRoute>)
  },
  {
    path: "highSchools/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <HighSchool />
      </ProtectedRoute>)
  },
  {
    path: "settings/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Settings />
      </ProtectedRoute>)
  },
  {
    path: "photos/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Photos />
      </ProtectedRoute>)
  },
  {
    path: "help/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Help />
      </ProtectedRoute>)
  },
  {
    path: "content/*",
    element: (
      <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
        <Content />
      </ProtectedRoute>)
  },
  {
    path: "userMangment/*",
    // element: <UserMangment />
    element: (<ProtectedRoute requiredRole="admin" routeAuth="userMangment" >
      <UserMangment />
    </ProtectedRoute>)
  },
  {
    path: "changePassword/*",
    element: <ChangePassword />
  },
  {
    path: "admin/*",
    element: <AdminRoutes />,
  }
];

export default function ModuleRoutes() {
  return useRoutes(ModuleRoutesArray);
}
/** */

export default function MoudleRoutes() {
  let locationFromContext = useLocation();
  let location = locationFromContext;
  let component = locationFromContext;
     // component.substring(1);
  let mycomponent = component.pathname.split("/");
  let getContext = "";
  if(mycomponent.length >= 3){
    getContext = mycomponent[mycomponent.length-1];
    if(getContext === "view" || getContext === "save" || getContext === "new" || getContext === "edit" 
      || getContext === "all" || getContext === "create" || getContext === "filter"
      || getContext === "update" || getContext === "delete" || getContext === "search"
      || getContext === "add" || getContext === "delete" || getContext === "update"
    ){
      getContext = mycomponent[mycomponent.length-2];
    }
  }else if(mycomponent.length === 2){
    getContext = mycomponent[1];
    if(getContext === "view" || getContext === "save" || getContext === "new" || getContext === "edit" 
      || getContext === "all" || getContext === "create" || getContext === "filter"
      || getContext === "update" || getContext === "delete" || getContext === "search"
      || getContext === "add" || getContext === "delete" || getContext === "update"
    ){
      getContext = mycomponent[0];
    }
  }
  

  return useRoutes([{
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "*/*",
    element: <FERoutes getContext={getContext} />,
  },
  {
    path: "/*",
    element: <FERoutes getContext={getContext} />,
  }]
);
}
